import { render, staticRenderFns } from "./MoneyFormatField.vue?vue&type=template&id=44568faf&"
import script from "./MoneyFormatField.vue?vue&type=script&lang=js&"
export * from "./MoneyFormatField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports